"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardReplyOption')(function discardReplyOption(state) {
    var optionState = state.optionState;
    optionState.replyAllByDefault = null;
}));
//# sourceMappingURL=discardReplyOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reply-option/lib/actions/discardReplyOption.js
// module id = 5047
// module chunks = 2